import React from 'react';

import Select from 'corp/components/UI/Select';
import apiFetch, { defaultApiFetchErrorHandler } from '@scale/frontend-lib/api-fetch';

interface SelectOption {
  label: string;
  value: string;
}

interface ISelectCourse {
  onChange: (course: SelectOption) => void;
  value?: SelectOption;
}

const SelectCourse: React.FC<ISelectCourse> = ({ onChange, value }) => {
  const fetchCourses = async (search: string) => {
    try {
      const query = { search };
      const results = await apiFetch(null, `corp-api/find/courses`, { query });
      const options = results.courses.map((course: { name: any; id: any }) => {
        return {
          label: `${course.name} (${course.id})`,
          value: course.id,
        };
      });

      return {
        options,
      };
    } catch (error) {
      defaultApiFetchErrorHandler(error, { handleHttp: true });
      return [];
    }
  };

  return (
    <div>
      <Select
        {...{ onChange, value }}
        loadOptions={fetchCourses.bind(this)}
        ignoreCase
        placeholder="Course Name or ID"
      />
    </div>
  );
};

export default SelectCourse;
